import { LabelKey } from '../../context/screen-labels/screen-labels.model';

export type GetLabelFn = (
  key: LabelKey,
  options?: { plural?: boolean; capitalize?: 'first' | 'all' }
) => string;


export const getDisplayLabel = (raw?: string, getLabel?: GetLabelFn): string => {
  if (!raw) return '';
  const original = raw.trim();
  const lower = original.toLowerCase();
  const isPlural = lower.endsWith('s') || lower === 'subsidiaries';

  const map: Record<string, LabelKey> = {
    organisation: 'organisation',
    organisations: 'organisation',
    project: 'project',
    projects: 'project',
    subsidiary: 'subsidiary',
    subsidiaries: 'subsidiary',
    location: 'location',
    locations: 'location',
    vehicle: 'vehicle',
    vehicles: 'vehicle',
    supplier: 'supplier',
    suppliers: 'supplier',
    emission: 'emission',
    emissions: 'emission',
  };

  const key = map[lower];
  if (!key || !getLabel) return original;
  return getLabel(key, { plural: isPlural, capitalize: 'first' }) || original;
};


